export default __webpack_public_path__ + "static/ads-header-9d20eaea9628f4fb57e7640dcba965aa.svg";